export enum YesNo {
  YES = 'yes',
  NO = 'no',
}

export type ApiVersion = 'v1' | 'v3'
